/**
 * Bereiche, die noch nicht gebaut sind.
 *
 * Warum sie überhaupt in der Navigation stehen: Ein Backoffice, das nur einen
 * Punkt zeigt, sieht aus wie ein Werkzeug, das kaum etwas kann. Eines, das
 * seine Bereiche zeigt und ehrlich sagt, welcher noch fehlt, ist ein Plan,
 * den man mitlesen kann. Und wer etwas sucht, das noch nicht da ist, findet
 * hier die Antwort statt einer leeren Liste.
 *
 * Wichtig: Hier steht NICHT „demnächst verfügbar". Hier steht, was der
 * Bereich können wird und was bis dahin an seiner Stelle gilt.
 */

import { Seitenkopf } from '../Rahmen';
import { Karte, Meldung } from '../gestaltung/bausteine';

export type Bauplan = {
  titel: string;
  erklaerung: string;
  /** Was der Bereich können wird. */
  kommt: string[];
  /** Was bis dahin gilt — der Weg, der heute funktioniert. */
  solange: string;
};

export function BaldSeite(eigenschaften: { plan: Bauplan }) {
  const { plan } = eigenschaften;
  return (
    <>
      <Seitenkopf titel={plan.titel} erklaerung={plan.erklaerung} />

      <Meldung art="warnung" titel="Dieser Bereich ist noch nicht gebaut">
        {plan.solange}
      </Meldung>

      <div style={{ marginTop: 16 }}>
        <Karte titel="Was hier entstehen wird">
          <ul className="stapel" style={{ gap: 8 }}>
            {plan.kommt.map((punkt) => (
              <li key={punkt} className="reihe" style={{ gap: 8, alignItems: 'flex-start' }}>
                <span style={{ color: 'var(--indigo)', fontWeight: 700 }}>—</span>
                <span>{punkt}</span>
              </li>
            ))}
          </ul>
        </Karte>
      </div>
    </>
  );
}

/**
 * Die Baupläne aller noch offenen Bereiche, in der Reihenfolge der Umsetzung.
 *
 * Zurzeit leer: „Zeiten und Spesen" war der letzte Eintrag und ist gebaut.
 * Der Baustein bleibt trotzdem stehen — der nächste Bereich, der angekündigt
 * wird, bevor er fertig ist, soll wieder hier eingetragen werden können und
 * nicht als leere Liste in der Navigation auftauchen.
 */
export const BAUPLAENE: Record<string, Bauplan> = {};
